import { ComponentChildren, JSX } from 'preact';
import styles from './Button.module.css';

type ButtonClickEvent = JSX.TargetedMouseEvent<HTMLButtonElement>;

type Common = {
  children: ComponentChildren;
  full?: boolean;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  onClick?: (e: ButtonClickEvent) => void;
  class?: string;
  ariaLabel?: string;
};

export function PrimaryBtn({
  children,
  full = true,
  type = 'button',
  disabled = false,
  onClick,
  class: className,
  ariaLabel,
}: Common): JSX.Element {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel}
      class={`${styles.primary} ${full ? styles.full : ''} ${className ?? ''}`.trim()}
    >
      {children}
    </button>
  );
}

export function GhostBtn({
  children,
  full = true,
  type = 'button',
  disabled = false,
  onClick,
  class: className,
  ariaLabel,
}: Common): JSX.Element {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel}
      class={`${styles.ghost} ${full ? styles.full : ''} ${className ?? ''}`.trim()}
    >
      {children}
    </button>
  );
}
